import UserError from './UserError.js'

export class LeadHitUserError extends UserError {}
